(() => {
  if (window.ctfaGangBuilderPageReady) return;
  window.ctfaGangBuilderPageReady = true;
  const scopeSelector = 'product-info[data-product-id="8735019237611"]';
  const optionSelector = 'variant-selects fieldset.product-form__input--pill input[type="radio"]';
  const formatSize = (value) => {
    const match = String(value).match(/^\s*(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*(?:"|″|''|in(?:ches)?)?\s*$/i);
    return match ? `${match[1]} × ${match[2]}″` : null;
  };
  const nativeControl = (element) => element.matches('button, input, select, textarea, a[href], summary');
  const refresh = () => {
    document.querySelectorAll(scopeSelector).forEach((scope) => {
      const button = scope.querySelector('#gs-builder-btn');
      if (button && !nativeControl(button)) {
        if (button.getAttribute('role') !== 'button') button.setAttribute('role', 'button');
        if (button.getAttribute('tabindex') !== '0') button.setAttribute('tabindex', '0');
      }
      const inputs = Array.from(scope.querySelectorAll(optionSelector));
      inputs.forEach((input) => {
        const size = formatSize(input.value);
        if (!size) return;
        const label = Array.from(input.closest('fieldset').querySelectorAll('label[for]')).find((item) => item.htmlFor === input.id);
        if (!label) return;
        const text = Array.from(label.childNodes).find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
        if (text && text.textContent.trim() !== size) text.textContent = size;
      });
      const selected = inputs.find((input) => input.checked && formatSize(input.value));
      scope.querySelectorAll('[data-ctfa-gang-selected-size]').forEach((helper) => {
        const size = selected ? formatSize(selected.value) : '';
        if (helper.textContent !== size) helper.textContent = size;
      });
    });
  };
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; refresh(); });
  };
  document.addEventListener('change', (event) => {
    if (event.target instanceof Element && event.target.matches(optionSelector) && event.target.closest(scopeSelector)) refresh();
  });
  document.addEventListener('keydown', (event) => {
    if (!['Enter', ' ', 'Spacebar'].includes(event.key) || event.repeat || event.defaultPrevented) return;
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('#gs-builder-btn');
    if (!button || !button.closest(scopeSelector) || nativeControl(button)) return;
    if (event.target !== button && event.target.closest('button, input, select, textarea, a[href], [contenteditable="true"]')) return;
    event.preventDefault();
    if (button.matches('[disabled], [aria-disabled="true"], .disabled') || button.disabled || button.closest('[inert]')) return;
    button.click();
  });
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  refresh();
})();
